/* global axios */
import ApiClient from './ApiClient';

class TdfConfigAPI extends ApiClient {
  constructor() {
    super('tdf_config', { accountScoped: true });
  }

  show() {
    return axios.get(this.url);
  }

  update(data) {
    return axios.put(this.url, data);
  }

  bookings(params = {}) {
    return axios.get(`${this.url}/bookings`, { params });
  }

  dashboardStats() {
    return axios.get(`${this.url}/dashboard_stats`);
  }

  roomMap(params = {}) {
    return axios.get(`${this.url}/room_map`, { params });
  }

  updateRoomStatus(data) {
    return axios.post(`${this.url}/update_room_status`, data);
  }

  updateHousekeeping(data) {
    return axios.post(`${this.url}/update_housekeeping`, data);
  }
}

export default new TdfConfigAPI();
